import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/WeeklyCompensation/weekbv2_top_banner.png'
import _imports_1 from '@/assets/WeeklyCompensation/weekb_frame_top.png'
import _imports_2 from '@/assets/WeeklyCompensation/weekb_frame_bottom.png'
import _imports_3 from '@/assets/WeeklyCompensation/weekb_icon_time.png'
import _imports_4 from '@/assets/WeeklyCompensation/weekb_week_text.png'


const _hoisted_1 = { class: "week_container" }
const _hoisted_2 = { class: "top-text" }
const _hoisted_3 = { class: "from" }
const _hoisted_4 = { class: "to" }
const _hoisted_5 = { class: "top-compensation" }
const _hoisted_6 = { class: "top-profit" }
const _hoisted_7 = { class: "compensation-middle-card" }
const _hoisted_8 = { class: "middle-compensation" }
const _hoisted_9 = { class: "middle-available-compensation" }
const _hoisted_10 = { class: "middle-available-amount" }
const _hoisted_11 = { style: {"color":"#FFFFFF73","font-size":"20px"} }
const _hoisted_12 = { style: {"color":"#FFFFFF"} }
const _hoisted_13 = { style: {"color":"#FFFFFF"} }
const _hoisted_14 = { style: {"color":"#ffffff73"} }
const _hoisted_15 = { style: {"color":"#FFFFFF"} }
const _hoisted_16 = { class: "activity-title" }
const _hoisted_17 = { class: "activity-text" }
const _hoisted_18 = ["innerHTML"]

import { ref } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'weeklyCompensationView',
  setup(__props) {

// import CustomHeader from '@/components/common/customHeader.vue';
const availableBalance = ref(0);
const activityIntro = ref('')
const commissionList = ref([
    {
        "level": "1",
        "title": "-100,00",
        "value": "5%"
    },
    {
        "level": "2",
        "title": "-1.000,00",
        "value": "6%"
    },
    {
        "level": "3",
        "title": "-5.000,00",
        "value": "7%"
    },
    {
        "level": "4",
        "title": "-10.000,00",
        "value": "8%"
    },
    {
        "level": "5",
        "title": "-30.000,00",
        "value": "9%"
    },
    {
        "level": "6",
        "title": "-50.000,00",
        "value": "10%"
    },
    {
        "level": "7",
        "title": "-100.000,00",
        "value": "15%"
    },
    {
        "level": "8",
        "title": "-500.000,00",
        "value": "30%"
    }
]);

return (_ctx: any,_cache: any) => {
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_row = _resolveComponent("van-row")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_van_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_van_col, { span: "24" }, {
          default: _withCtx(() => _cache[0] || (_cache[0] = [
            _createElementVNode("div", { class: "weekly-banner" }, [
              _createElementVNode("img", {
                src: _imports_0,
                alt: "banner",
                class: "weekly-img"
              })
            ], -1)
          ])),
          _: 1
        })
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_van_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_van_col, { span: "24" }, {
            default: _withCtx(() => _cache[1] || (_cache[1] = [
              _createElementVNode("div", { class: "compensation-card" }, [
                _createElementVNode("img", {
                  src: _imports_1,
                  alt: "banner",
                  class: "top-card-bg"
                })
              ], -1)
            ])),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_van_row, { class: "top-box" }, {
        default: _withCtx(() => [
          _createVNode(_component_van_col, { span: "24" }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_2, [
                _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t('weeklyCompensation.the')), 1),
                _cache[2] || (_cache[2] = _createElementVNode("span", { class: "from-date" }, " 2025-05-05 05:30 ", -1)),
                _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t('weeklyCompensation.to')), 1),
                _cache[3] || (_cache[3] = _createElementVNode("span", { class: "to-date" }, " 2025-05-12 05:30 ", -1))
              ]),
              _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t('weeklyCompensation.weeklyCompensation')) + ":", 1),
              _cache[4] || (_cache[4] = _createElementVNode("span", { class: "top-compensation-amount" }, [
                _createTextVNode("R$ "),
                _createElementVNode("span", { style: {"color":"#000"} }, "0")
              ], -1)),
              _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t('weeklyCompensation.profit')) + "：", 1),
              _cache[5] || (_cache[5] = _createElementVNode("span", { class: "top-profit-amount" }, "R$ 0", -1))
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_van_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_van_col, { span: "24" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_7, [
                _cache[7] || (_cache[7] = _createElementVNode("img", {
                  src: _imports_2,
                  alt: "banner",
                  class: "middle-card-bg"
                }, null, -1)),
                _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t('weeklyCompensation.distribute')), 1),
                _cache[8] || (_cache[8] = _createElementVNode("span", { class: "middle-date" }, "2025-05-13 01:30", -1)),
                _cache[9] || (_cache[9] = _createElementVNode("img", {
                  src: _imports_3,
                  alt: "banner",
                  class: "middle-time-icon"
                }, null, -1)),
                _cache[10] || (_cache[10] = _createElementVNode("img", {
                  src: _imports_4,
                  alt: "banner",
                  class: "middle-moneybag-icon"
                }, null, -1)),
                _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t('weeklyCompensation.available')), 1),
                _createElementVNode("span", _hoisted_10, [
                  _cache[6] || (_cache[6] = _createTextVNode("R$ ")),
                  _createElementVNode("span", _hoisted_11, _toDisplayString(availableBalance.value), 1)
                ]),
                _createElementVNode("div", {
                  class: _normalizeClass(availableBalance.value > 0 ? 'exchange-btn exchange-btn-active' : 'exchange-btn exchange-btn-disabled')
                }, null, 2)
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_van_row, { class: "detail-table" }, {
        default: _withCtx(() => [
          _createVNode(_component_van_col, {
            span: "11",
            class: "table-title"
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.$t('weeklyCompensation.profit')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_van_col, { span: "2" }),
          _createVNode(_component_van_col, {
            span: "11",
            class: "table-title"
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.$t('weeklyCompensation.compensation')), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(commissionList.value, (i, index) => {
        return (_openBlock(), _createBlock(_component_van_row, {
          class: "detail-stable",
          key: i+'i'
        }, {
          default: _withCtx(() => [
            _createVNode(_component_van_col, {
              span: "11",
              class: _normalizeClass(['table-row', index % 2 === 0 ? 'light' : 'dark'])
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_14, _toDisplayString(i.title), 1)
              ]),
              _: 2
            }, 1032, ["class"]),
            _createVNode(_component_van_col, { span: "2" }),
            _createVNode(_component_van_col, {
              span: "11",
              class: _normalizeClass(['table-row', index % 2 === 0 ? 'light' : 'dark'])
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_15, _toDisplayString(i.value), 1)
              ]),
              _: 2
            }, 1032, ["class"])
          ]),
          _: 2
        }, 1024))
      }), 128)),
      _createVNode(_component_van_row, { class: "activity-title-row" }, {
        default: _withCtx(() => [
          _createVNode(_component_van_col, { span: "6" }, {
            default: _withCtx(() => _cache[11] || (_cache[11] = [
              _createElementVNode("div", { class: "left-img" }, null, -1)
            ])),
            _: 1
          }),
          _createVNode(_component_van_col, { span: "12" }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.$t('common.activityTitle')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_van_col, { span: "6" }, {
            default: _withCtx(() => _cache[12] || (_cache[12] = [
              _createElementVNode("div", { class: "right-img" }, null, -1)
            ])),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_van_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_van_col, { span: "24" }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_17, [
                _createElementVNode("p", {
                  innerHTML: _ctx.$t('weeklyCompensation.activityContent')
                }, null, 8, _hoisted_18)
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ])
  ], 64))
}
}

})